import { tuplesToObjects } from '../utils'
import { renderListingImage } from './listingImageRenderer'
import { renderListingPrice } from './listingPriceRenderer'
import renderWishlistButton from './wishlistButtonRenderer'
import godsEye from '../../images/icons/gods-eye.svg'
import sparkle from '../../images/icons/sparkle-midnight-black.svg'
import sponsoredIcon from '../../images/icons/sponsored.svg'
import { prependLocale, getLocaleFromPath } from '../../utils/localeHelpers'

function getCurrentLocale () {
  return getLocaleFromPath(window.location.pathname)
}

export function hrefFromHit (hit) {
  return prependLocale(`/${hit.path_hierarchy}/${hit.slug}`, getCurrentLocale())
}

export function getWishlistedItemsFromPage () {
  // Absent on pages with no listing grid: Vera's carousel can open over any page.
  const wishlistedTuplesValue = document.querySelector('.vjs-wishlist-item-ids')?.value
  const wishlistedTuples = wishlistedTuplesValue ? JSON.parse(wishlistedTuplesValue) : []
  return tuplesToObjects(wishlistedTuples, 'wishlistID', 'listingID')
}

function buildCategoryLink (hit) {
  const pathParts = hit.path_hierarchy ? hit.path_hierarchy.split('/') : []
  const firstThreeParts = pathParts.slice(0, 3).join('/')
  return {
    href: prependLocale(`/${firstThreeParts}`, getCurrentLocale()),
    label: (hit.product_type_name && hit.product_type_name.trim() !== '')
      ? hit.product_type_name
      : (hit.most_specific_category_name || '')
  }
}

export function getHitHTML (hit, wishlistedItems, userStatus, tileOptions) {
  const { objectID, title, renderSponsoredListing } = hit
  // StandardJS doesn't like snake case variable e.g: free_uk_delivery_for_algolia
  const freeLondonOrUkDelivery = hit.free_london_or_uk_delivery
  const { isTradeBuyer, isLoggedIn } = userStatus
  const { plpPage = false, showViewSimilar = true, rankingDebug = false, showCategoryLink = false } = tileOptions

  const { href: categoryLinkHref, label: categoryLinkLabel } = showCategoryLink
    ? buildCategoryLink(hit)
    : { href: '', label: '' }

  const href = hrefFromHit(hit)
  const similarHref = prependLocale(`/visual_discovery/${hit.slug}`, getCurrentLocale())
  const wishlistedHit = wishlistedItems.find(item => item.listingID === parseInt(objectID))
  const wishlistedHitID = wishlistedHit ? wishlistedHit.wishlistID : null
  const openNewTabEl = document.querySelector('#vjs-open-listing-new-tab')
  const openNewTab = JSON.parse(openNewTabEl?.value)
  const isDesktopEl = document.querySelector('#vjs-device-desktop')
  const isDesktop = JSON.parse(isDesktopEl?.value)
  const viewSimilarText = document.querySelector('#vjs-view-similar-text')?.value
  const discoverText = document.querySelector('#vjs-discover-text')?.value
  const showRedesignedProductTile = (plpPage || onHomePage() || onPDP())

  // data-productid is picked up by a Visibility Trigger on GTM
  if (showRedesignedProductTile) {
    return `
      <div class="vsd-listing__container vsd-listing__container-hover-shadow flex flex-col justify-between rounded px-12 bg-white vjs-results-product-click"
        data-productid="${objectID}"
        ${listingTileDataAttributes(hit)}
      >
        ${renderWishlistButton(objectID, wishlistedHitID, isLoggedIn, 'within-image')}
        <a class="vsd-listing__image-container vsd-listing__image-container-2025-redesign content-center border-none" ${openNewTab && isDesktop ? 'target="_blank"' : ''} href="${href}" ${listingTileDataAttributes(hit)}>
          ${renderListingImage(hit, showRedesignedProductTile)}
        </a>
        ${showViewSimilar && !hit.sold ? `<span data-masked-url="${similarHref}" class="vsd-listing__discover-tag vjs-masked-url vjs-amplitude-custom-click" data-amplitude-component-name="Listing Tile Discover" data-amplitude-listing-id="${objectID}"><img src="${sparkle}" alt="" class="vsd-listing__discover-icon w-18 shrink-0"><span class="max-599:sr-only">${discoverText}</span></span>` : ''}

        <div class="vsd-listing__info-container">
          <a class="vsd-listing__click-area" ${openNewTab && isDesktop ? 'target="_blank"' : ''} href="${href}" ${listingTileDataAttributes(hit)}></a>
          <div class="flex flex-col w-full text-size-smm max-599:text-size-xxsm">
            <div class="font-bold grow mb-8 min-h-[40px] line-clamp-2 max-599:min-h-0">
              ${title}
            </div>
            <div class="grow mb-8">
              <div>${renderListingPrice(hit, isTradeBuyer, showRedesignedProductTile)}</div>
            </div>
            ${(renderSponsoredListing)
              ? `<div class="mb-8 grow max-599:mb-0">
                <span class="text-midnight-black-40 text-size-sm max-599:text-size-[10px]">Sponsored listing</span>
              </div>`
              : ''
            }
          </div>
        </div>
        ${
          showCategoryLink
            ? `<div class="mb-8 grow max-599:mb-0 text-left">
                <a class="flex w-full items-center max-599:text-size-[10px] no-underline text-midnight-black" target="_blank" href="${categoryLinkHref}">
                  ${categoryLinkLabel} <span class="vsd-chevron-right-black"></span>
                </a>
              </div>`
            : ''
        }
      </div>
      ${rankingDebug ? rankingDebugInfo(hit) : ''}
    `
  } else {
    return `
      <div class="vsd-listing__container vjs-results-product-click"
        data-productid="${objectID}"
        ${listingTileDataAttributes(hit)}
      >
        <a class="vsd-listing__image-container vsd-aspect-ratio-500-350 vsd-listing__image-hover-shadow" ${openNewTab && isDesktop ? 'target="_blank"' : ''} href="${href}" ${listingTileDataAttributes(hit)}>
          ${renderListingImage(hit)}
        </a>
        ${showViewSimilar ? `<span data-masked-url="${similarHref}" class="vsd-listing__similar-tag vjs-listing__similar-tag vsd-listing-container__show-child-on-hover vjs-masked-url vjs-similar-query">${viewSimilarText} <img src="${godsEye}" class="inline"></span>` : ''}
        <div class="vsd-listing__info-container">
          <a class="vsd-listing__click-area vjs-results-product-click" ${openNewTab && isDesktop ? 'target="_blank"' : ''} href="${href}" ${listingTileDataAttributes(hit)}></a>
          <div class="flex flex-col w-full">
            <div class="vsd-listing__title grow w-4/5">
              ${title}
            </div>
            ${renderSponsoredListing
              ? `<a class="vsd-listing__title grow vjs-results-product-click" ${openNewTab && isDesktop ? 'target="_blank"' : ''} href="${href}" ${listingTileDataAttributes(hit)}>
                <img src="${sponsoredIcon}" class="inline relative mb-2" />
                <span class="text-midnight-black-40 text-size-sm">Sponsored</span>
              </a>`
              : ''
            }
            <a class="grow ga-ee-product-click" ${openNewTab && isDesktop ? 'target="_blank"' : ''} href="${href}" ${listingTileDataAttributes(hit)}>
              ${renderListingPrice(hit, isTradeBuyer)}
            </a>
          </div>
          ${renderWishlistButton(objectID, wishlistedHitID, isLoggedIn, 'small')}
          ${plpPage && freeLondonOrUkDelivery ? '<div class="vsd-badge__success mt-4 mr-4">FREE DELIVERY</div>' : ''}
        </div>
      </div>

      ${rankingDebug ? rankingDebugInfo(hit) : ''}
    `
  }
}

export function getImageOnlyHitHTML (hit) {
  const { objectID } = hit
  const href = hrefFromHit(hit)
  return `
    <div class="vsd-listing__container vjs-results-product-click flex-none pr-24 w-1/6 max-1199:w-1/5 max-887:w-1/4 max-599:w-1/3 max-480:w-1/2"
      data-productid="${objectID}"
      ${listingTileDataAttributes(hit)}
    >
      <a class="vsd-listing__image-container vsd-aspect-ratio-500-350 vsd-listing__image-hover-shadow" target="_blank" href="${href}" ${listingTileDataAttributes(hit)}>
        ${renderListingImage(hit)}
      </a>
    </div>
  `
}

function listingTileDataAttributes (hit) {
  const dataAttributes = `
    data-id='${hit.objectID}'
    data-title='${hit.title}'
    data-price='${hit.price}'
    data-brand='${hit.brand_name}'
    data-category='${hit.category_name}'
    data-designer='${hit.designed_by_name}'
    data-promotion_level='${hit.promotion_level}'
    data-position='${hit.__position}'
    data-queryid='${hit.__queryID}'
    ${hit.vinterior_sponsored_listing ? `data-vinterior-sponsored-listing='${hit.vinterior_sponsored_listing}'` : ''}
  `
  return dataAttributes
}

// `_rankingInfo` comes from Algolia's `getRankingInfo: true` and has no Typesense
// equivalent — search.js only sets that parameter on the Algolia path. Reading it
// unguarded threw a TypeError for anyone opening a Typesense PLP with
// ?ranking_debug, taking the whole tile grid down with it.
//
// On Typesense the equivalent signals are the precomputed ranking fields below
// (which are shown either way) plus `text_match_info` in the raw response.
function algoliaRankingDebugInfo (hit) {
  const info = hit._rankingInfo
  if (!info) return 'No _rankingInfo (Typesense — see compacted_boost_score)<br>'

  return `
      User Score ${info.userScore}<br>
      ${info.personalization ? `textualRelevanceBucket ${info.personalization.textualRelevanceBucket}<br>` : ''}
      firstMatchedWord ${info.firstMatchedWord}<br>
      nbTypos ${info.nbTypos}<br>
      geoDistance ${info.geoDistance}<br>
      geoPrecision ${info.geoPrecision}<br>
      filters ${info.filters}<br>
      ${info.personalization ? `filtersScore ${info.personalization.filtersScore}<br>` : ''}
      nbExactWords ${info.nbExactWords}<br>
      proximityDistance ${info.proximityDistance}<br>
  `
}

function rankingDebugInfo (hit) {
  return `
    <div>
      Available ${hit.can_be_added_to_basket} ID: ${hit.objectID}<br>
      Boost score ${hit.boost_score}<br>
      Freshness ${hit.freshness_threshold}<br>
      Granular Freshness ${hit.granular_freshness_threshold}<br>
      Page views ${hit.page_views}<br>
      Published ${hit.published_at_int}<br>
      Compacted boost ${hit.compacted_boost_score}<br>
      Commercial boost ${hit.commercial_boost_score} / compacted ${hit.commercial_compacted_boost_score}<br>
      Premium boost ${hit.premium_boost_score} / compacted ${hit.premium_compacted_boost_score}<br>
      Engagement ${hit.engagement_score}<br>
      ${algoliaRankingDebugInfo(hit)}
    </div>
    <div>
      lvl0 ${hit.category_name}<br>
      lvl1 ${hit.subcategory_name}<br>
      lvl2 ${hit.product_type_name}<br>
      Vibes ${hit.vibe_names}<br>
      Period ${hit.period_name}<br>
      Year ${hit.year_of_manufacture}<br>
      Price RC ${hit.price_range_category}<br>
      Colour ${hit.color_name}<br>
      Material ${hit.main_material_name}<br>
      Seller score ${hit.seller_overall_score}<br>
    </div>
  `
}

export function getGiftCardTile () {
  return `
    <div class="vsd-listings__content-tile bg-bone-white rounded max-599:col-span-2 max-599:rounded-none">
      <div class="flex flex-col text-center">
        <img class="rounded-t max-599:hidden" src="https://assets-vinterior-0.vinterior.co/static-assets/plp_gift_card_tile_big.jpg" />
        <img class="hidden max-599:block h-[152px] rounded-none object-cover" src="https://assets-vinterior-0.vinterior.co/static-assets/plp_gift_card_tile.jpg" />
        <div class="text-midnight-black my-20 mx-16">
          <div class="mb-28">
            Give the gift of choice. A Vinterior gift card is the perfect gift for those who like to choose for themselves.
          </div>
          <a href="/gift_cards"
            class="vsd-button__filled w-full bg-atlantic-green text-bone-white vjs-amplitude-custom-click"
            data-amplitude-component-name="Buy an e-gift card"
          > Buy an e-gift card </a>
        </div>
      </div>
    </div>
  `
}

export function getTradeTile () {
  return `
    <div class="vsd-listings__content-tile bg-atlantic-green rounded max-599:col-span-2 max-599:rounded-none">
      <div class="flex flex-col text-center">
        <img class="rounded-t max-599:hidden" src="https://assets-vinterior-0.vinterior.co/static-assets/trade-support-big.jpg" />
        <img class="hidden max-599:block h-[152px] rounded-none object-cover" src="https://assets-vinterior-0.vinterior.co/static-assets/trade-support.jpg" />
        <div class="text-white my-32 mx-16">
          <div>Our in-house specialists offer end to end support, procurement and more.</div>
        </div>
        <a href="mailto:trade@vinterior.co" class="vsd-button__tonal-lime mx-16 mb-32 text-atlantic-green hover:text-atlantic-green vjs-trade-tile-cta vjs-amplitude-custom-click" data-amplitude-component-name="VIP tile - launch chat CTA">
          Chat with us
        </a>
      </div>
    </div>
  `
}

function onHomePage () {
  return window.location.pathname === '/'
}

function onPDP () {
  return Boolean(document.getElementById('vjs-pdp'))
}
